/* eslint-disable no-useless-escape */
import { Directive, Input, OnChanges } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator, Validators } from '@angular/forms';

// please do not use any flags when changing constants below.
// from my perspective, too few protocols are accepted. What about ssh, ws, wss and many others?
const _approvedOptionalProtocolsRegex = /(https?:\/\/|ftps?:\/\/|file:\/\/)?/;
const _anyOptionalProtocolRegex = /([a-z0-9]+:\/\/)?/;
const _urlRegexWithoutProtocol =
  /[a-z0-9[\]:?]+([-.:]{1}[a-z0-9[\]]+)*(:|\.)[a-z0-9[\]]{1,5}(:[0-9]{1,5})?(\/.*)?/;
export class CommonRegEx {
  // tslint:disable-next-line:max-line-length
  static readonly IP_REGEX: RegExp =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  // eslint-disable-next-line no-useless-escape
  static readonly HOST_NAME: RegExp =
    /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;
  // tslint:disable-next-line:max-line-length
  static readonly IPV6: RegExp =
    /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  // tslint:disable-next-line:max-line-length
  static readonly IP_V4_V6: RegExp =
    /((^\s*((([0-9]|[0-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[0-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;

  //tslint:disable-next-line:max-line-length
  static readonly SUBNET_MASK_REGEX: RegExp =
    /^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$/;

  // tslint:disable-next-line:max-line-length
  static readonly DNS_NAME: RegExp =
    /^(s*((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))s*$)|(^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9-]*[A-Za-z0-9])$)|(^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*)$/;

  // tslint:disable-next-line:max-line-length
  static readonly EMAIL: RegExp =
    /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

  // tslint:disable-next-line:max-line-length
  static readonly HH_MM_SS_REGEX: RegExp = /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/;

  // tslint:disable-next-line:max-line-length
  static readonly COLON_TWO_CHARACTORS: RegExp = /([^:]{2}(?!:))/g;

  // eslint-disable-next-line no-useless-escape
  static readonly IP_PORT: RegExp =
    /^(([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])\.)*([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])(:[0-9]+)?$/;

  static readonly SUBNET_IPv6 = new RegExp('^\\d+$');
  // eslint-disable-next-line no-useless-escape
  static readonly OVERLAY_NAME: RegExp = /^[a-zA-Z0-9\_\-\.\/]+$/;
  static readonly LATITUDE =
    /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/;
  static readonly LONGITUDE =
    /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/;

  /**
   * Early versions of this regex limited themselves to very few URL protocols (eg, http(s), ftp, file).
   * there are many more (https://www.iana.org/assignments/uri-schemes/uri-schemes.xhtml), and some of them
   * are totally reasonable in corporate world (ssh, ws, wss, snmp, etc..)
   * therefore, a generic version of URL matcher should accept any protocol.
   * if your use case demands to allow less protocols, please construct another URL regex that limits protocols to accept.
   * And some more changes to think about: protocol://user:password@www.something.com
   * This is a totally valid URL syntax - but the regex below would not recognize it.
   */
  static readonly ANY_URL_REGEX: RegExp = new RegExp(
    `^${_anyOptionalProtocolRegex.source}${_urlRegexWithoutProtocol.source}$`
  );
  // only approved URL protocols are recognized. For URL to be recognized as valid, protocol must be present AND approved, or absent.
  static readonly URL_WITH_APPROVED_PROTO_REGEX = new RegExp(
    `^${_approvedOptionalProtocolsRegex.source}${_urlRegexWithoutProtocol.source}$`
  );

  //tslint:disable-next-line:max-line-length
  static readonly IP_V4_CIDR: RegExp =
    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([0-9]|[1-2][0-9]|3[0-2]))$/;
  //tslint:disable-next-line:max-line-length
  static readonly IP_V6_CIDR: RegExp =
    /^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*(\/([0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8]))$/;
  static readonly MAC: RegExp = /^([0-9a-fA-F]{2}[:-]){5}([0-9a-fA-F]{2})$/;

  /*-----------------------------------------------------------------------------------------------------------*/
  //tslint:disable-next-line:max-line-length
  static readonly IP4_STR =
    '((25[0-5]|(2[0-4]|1[0-9]|[1-9])?[0-9])(\\.(25[0-5]|(2[0-4]|1[0-9]|[1-9])?[0-9])){3})';
  //tslint:disable-next-line:max-line-length
  static readonly IP6_STR =
    '\\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))(%.+)?\\s*';
  static readonly MAC_STR = '^(([0-9a-fA-F]{2}[:-]){5}([0-9a-fA-F]{2}))$';
  static readonly MAC_STR_3 = '^(([0-9a-fA-F]{2}[:-]){2}([0-9a-fA-F]{2}))$';
  static readonly IP4_CIDR_SUFFIX_STR = '\\/\\d{1,2}';
  static readonly IP6_CIDR_SUFFIX_STR = '\\/\\d{1,3}';
  static readonly CIDR_IP4_STR = '^' + CommonRegEx.IP4_STR + CommonRegEx.IP4_CIDR_SUFFIX_STR + '$';
  static readonly CIDR_IP6_STR = '^' + CommonRegEx.IP6_STR + CommonRegEx.IP6_CIDR_SUFFIX_STR + '$';
  static readonly CIDR_STR =
    '^' +
    CommonRegEx.IP4_STR +
    CommonRegEx.IP4_CIDR_SUFFIX_STR +
    '$|^' +
    CommonRegEx.IP6_STR +
    CommonRegEx.IP6_CIDR_SUFFIX_STR +
    '$';
  static readonly SINGLE_STR =
    '^' +
    CommonRegEx.IP4_STR +
    '$|^' +
    CommonRegEx.IP6_STR +
    '$|^' +
    CommonRegEx.MAC_STR +
    '$|^' +
    CommonRegEx.MAC_STR_3 +
    '$';
  static readonly SINGLE_IP4_IP6_STR =
    '^' + CommonRegEx.IP4_STR + '$|^' + CommonRegEx.IP6_STR + '$';
  static readonly RANGE_IP4_STR =
    '(' + CommonRegEx.IP4_STR + '\\s*-\\s*' + CommonRegEx.IP4_STR + ')';
  static readonly RANGE_IP6_STR =
    '(' + CommonRegEx.IP6_STR + '\\s*-\\s*' + CommonRegEx.IP6_STR + ')';
  static readonly RANGE_MAC_STR =
    '(' + CommonRegEx.MAC_STR + '\\s*-\\s*' + CommonRegEx.MAC_STR + ')';
  //tslint:disable-next-line:max-line-length
  static readonly RANGE_STR =
    '(' +
    CommonRegEx.IP4_STR +
    '\\s*-\\s*' +
    CommonRegEx.IP4_STR +
    '$)|(' +
    CommonRegEx.IP6_STR +
    '\\s*-\\s*' +
    CommonRegEx.IP6_STR +
    '$)|(' +
    CommonRegEx.MAC_STR +
    '\\s*-\\s*' +
    CommonRegEx.MAC_STR +
    '$)';
  static readonly RANGE_IP4_IP6_STR =
    '(' +
    CommonRegEx.IP4_STR +
    '\\s*-\\s*' +
    CommonRegEx.IP4_STR +
    '$)|(' +
    CommonRegEx.IP6_STR +
    '\\s*-\\s*' +
    CommonRegEx.IP6_STR +
    '$)';
  static readonly SINGLE_OR_RANGE_OR_CIDR =
    '^(' +
    CommonRegEx.SINGLE_STR +
    ')|(' +
    CommonRegEx.RANGE_STR +
    ')|(' +
    CommonRegEx.CIDR_STR +
    ')$';
  static readonly SINGLE_OR_RANGE_IP4_OR_CIDR =
    '^(' +
    CommonRegEx.SINGLE_STR +
    ')|(' +
    CommonRegEx.RANGE_IP4_STR +
    ')|(' +
    CommonRegEx.CIDR_STR +
    ')$';
  static readonly SINGLE_IP4_IP6_OR_RANGE_IP4_OR_CIDR =
    '^(' +
    CommonRegEx.SINGLE_IP4_IP6_STR +
    ')|(' +
    CommonRegEx.RANGE_IP4_STR +
    ')|(' +
    CommonRegEx.CIDR_STR +
    ')$';

  static readonly SINGLE_OR_RANGE_IP4 =
    '^(' + CommonRegEx.SINGLE_STR + ')|(' + CommonRegEx.RANGE_IP4_STR + ')$';
  static readonly SINGLE_IP4_IP6_OR_RANGE_IP4 =
    '^(' + CommonRegEx.SINGLE_IP4_IP6_STR + ')|(' + CommonRegEx.RANGE_IP4_STR + ')$';

  static readonly COLOR_RRGGBB_STR = /^#[0-9A-F]{6}$/i;
  static readonly DEVICE_PARENT_STR = /^(?<device_name>[^(]+)\((?<parent_name>.+)\)$/;

  static readonly IP4_REGEX = new RegExp(CommonRegEx.IP4_STR);
  static readonly IP6_REGEX = new RegExp(CommonRegEx.IP6_STR);
  static readonly MAC_REGEX = new RegExp(CommonRegEx.MAC_STR);
  static readonly MAC_REGEX3 = new RegExp(CommonRegEx.MAC_STR_3);
  static readonly SINGLE_REGEX = new RegExp(CommonRegEx.SINGLE_STR);
  static readonly CIDR_IP4_REGEX = new RegExp(CommonRegEx.CIDR_IP4_STR);
  static readonly CIDR_IP6_REGEX = new RegExp(CommonRegEx.CIDR_IP6_STR);
  static readonly CIDR_REGEX = new RegExp(CommonRegEx.CIDR_STR);
  static readonly RANGE_IP4_REGEX = new RegExp(CommonRegEx.RANGE_IP4_STR);
  static readonly RANGE_IP6_REGEX = new RegExp(CommonRegEx.RANGE_IP6_STR);
  static readonly RANGE_MAC_REGEX = new RegExp(CommonRegEx.RANGE_MAC_STR);
  static readonly RANGE_REGEX = new RegExp(CommonRegEx.RANGE_STR);
  static readonly COLOR_RRGGBB_REGEX = new RegExp(CommonRegEx.COLOR_RRGGBB_STR);
  static readonly DEVICE_PARENT_REGEX = new RegExp(CommonRegEx.DEVICE_PARENT_STR);

  static readonly URL_REGEX = /(((https?:\/\/)|(www\.))[^\s]+)/g;
  // eslint-disable-next-line no-useless-escape
  static readonly APPLICATION_URL_REGEX =
    /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))|(^\s*((?=.{1,255}$)(?=.*[A-Za-z].*)[0-9A-Za-z](?:(?:[0-9A-Za-z]|\b-){0,61}[0-9A-Za-z])?(?:\.[0-9A-Za-z](?:(?:[0-9A-Za-z]|\b-){0,61}[0-9A-Za-z])?)*)\s*$)|((http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))|((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]):([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])([-a-zA-Z@:%_\+.~#?&//=][-a-zA-Z0-9@:%_\+.~#?&//=]*)?$)/;
  static readonly URL_START_REGEX = '^(http|https)://';
  static readonly NO_DECIMAL_REGEX = /^\d+$/;
}

@Directive({
  selector: '[matchPattern][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MatchPatternValidator, multi: true }]
})
// original PatternValidator from Angular does not support expressions as 'input' to validator
// instead, it takes given string 'as is' - which means we can't  pass a regex from component.ts..
export class MatchPatternValidator implements OnChanges, Validator {
  @Input('matchPattern') // eslint-disable-line
  key: string;
  validatorFn: any = Validators.nullValidator; // eslint-disable-line

  ngOnChanges(): void {
    this.validatorFn = this.key ? this.configureValidator(this.key) : Validators.nullValidator;
  }

  // eslint-disable-next-line
  configureValidator(pattern: string | RegExp): (currentValue: any) => { matchPattern: string } {
    return currentValue => {
      if (!currentValue) {
        return null;
      }
      if (currentValue.match(pattern)) {
        return null;
      }
      return { matchPattern: 'wrong' };
    };
  }

  // eslint-disable-next-line
  validate(control: UntypedFormControl): any {
    return this.validatorFn(control.value);
  }
}
